import React, { useEffect } from "react";
import { Chart as ChartJs, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement } from "chart.js";
import { Line } from 'react-chartjs-2';
import styled from 'styled-components';
import { dateFormat } from '../../utils/dateFormat'
import { useGlobalContext } from "../../context/GlobalContext";

ChartJs.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement);

function Chart() {
  const { incomes, expenses, getExpenses, getIncomes } = useGlobalContext();

  useEffect(() => {
    getExpenses();
    getIncomes();
  }, []);

  const data = {
    labels: incomes.map((inc) => {
      const { date } = inc
      return dateFormat(date)
    }),
    datasets: [
      {
        label: 'Income',
        data: [
          ...incomes.map((income) => {
            const { amount } = income
            return amount
          })
        ],
        backgroundColor: 'green',
        tension: .2
      },
      {
        label: 'Expenses',
        data: [
          ...expenses.map((expense) => {
            const { amount } = expense
            return amount
          })
        ],
        backgroundColor: 'red',
        tension: .2
      }
    ]
  }

  return <ChartStyled>
    <Line data={data} />
  </ChartStyled>;
}

const ChartStyled = styled.div`
    background: #FCF6F9;
    border: 2px solid #FFFFFF;
    box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.06);
    padding: 1rem;
    border-radius: 20px;
    height: 100%;
`;


export default Chart;
